import React from "react";
import styled from "styled-components";

import { Text } from "./../../../StyledComponents";
import PurplePromotionIcon from '../Svg/PurplePromotionIcon';

const SummaryRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2px 0;
  width: 100%;
`;

const SummaryParentRowWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const OnDiscountIconWrapper = styled.div`
  padding-right: 10px;
`;

export const SummaryRow = (props) => {
  return (
    <SummaryParentRowWrapper>

      {props.onDiscount &&
        <OnDiscountIconWrapper>
          <PurplePromotionIcon />
        </OnDiscountIconWrapper>
      }
      <SummaryRowWrapper
        automationid={`SalesLeads_Div_SummaryRowWrap${props.title}_1`}
      >

        <Text
          fontWeight={props.boldTitle ? 700 : 400}
          color={props.onDiscountColor ? "#9C2AA0" : props.boldTitle ? "#282828" : "#666"}
          automationid={`SalesLeads_P_SummaryRow${props.title}_1`}
        >
          {`${props.title}${props.value ? ':' : ''}`}
        </Text>
        <Text
          fontWeight={props.boldTitle ? 900 : 400}
          automationid={`SalesLeads_P_SummaryRow${props.title}_2`}
        >
          {props.value}
        </Text>
      </SummaryRowWrapper>
    </SummaryParentRowWrapper>

  );
};
